var exports = {
  "w": "logo__bX9RKh",
};

module.exports = exports;
